import { render, staticRenderFns } from "./PaypalButton.vue?vue&type=template&id=9ab52dc8&scoped=true&"
import script from "./PaypalButton.vue?vue&type=script&lang=js&"
export * from "./PaypalButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ab52dc8",
  null
  
)

export default component.exports